export default class FetcherError extends Error {}
